import { createContext, Dispatch } from "react";
import { SkillsReducerAction } from "ui/account/Skills/reducers";

/* use to pass dispatch only; the dispatch context never changes, 
so components that read it don’t need to re-render unless they 
also need the application state */
const SkillsContext = createContext<Dispatch<SkillsReducerAction>>(() => {});

export default SkillsContext;
